const API_KEY = "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";

export async function sendLeadEmail(formData) {
  try {
    console.log('Attempting to send email with data:', formData);
    
    const data = {
      sender: {
        name: "payassured.in",
        email: "replies@payassured.in"
      },
      to: [{
        email: "sales@ratioventures.in",
        name: "Sales Team"
      }],
      subject: "New Lead Alert - Website Inquiry",
      htmlContent: `
        <h2>New Lead Alert - Website Inquiry</h2>
        <p>A new potential customer has submitted their details:</p>
        <ul>
            <li><strong>Name:</strong> ${formData.name}</li>
            <li><strong>Phone Number:</strong> ${formData.phone}</li>
            <li><strong>Email:</strong> ${formData.email}</li>
            <li><strong>Annual Turnover:</strong> ${formData.turnover}</li>
            <li><strong>Submission Time:</strong> ${new Date().toLocaleString()}</li>
        </ul>
        <p>Please follow up with this lead as soon as possible.</p>
        <br>
        <p>Best regards,<br>PayAssured System</p>
      `
    };

    const response = await fetch('https://api.sendinblue.com/v3/smtp/email', {
      method: 'POST',
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json',
        'api-key': API_KEY
      },
      body: JSON.stringify(data)
    });

    if (!response.ok) {
      const errorData = await response.json();
      throw new Error(`API error: ${errorData.message || response.statusText}`);
    }

    const result = await response.json();
    console.log('API Response:', result);
    return true;
  } catch (error) {
    console.error('Email sending error:', {
      message: error.message,
      status: error.status
    });
    throw error;
  }
} 